<template>
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 -960 960 960"
    :fill="props.fill"
    :stroke="props.stroke"
    :stroke-width="props.strokeWidth"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M702-480 560-622l57-56 85 85 170-170 56 57-226 226Zm-342 0q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm80-80h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 260Zm0-340Z"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  size: {
    type: String,
    default: "24",
  },
  fill: {
    type: String,
    default: "#1E2648",
  },
  stroke: {
    type: String,
    default: "none",
  },
  strokeWidth: {
    type: String,
    default: "0",
  },
});
</script>
